import type { CSSProperties } from "react";

import { cn } from "@/components/ui/utils";

export function EmptySection({
  height = 0,
  heightPx = null,
}: {
  height?: number;
  heightPx?: number;
}) {
  return (
    <div
      className={cn(
        heightPx !== null
          ? "h-(--height-px)"
          : height === 0
            ? "pt-0 pb-0"
            : "pt-(--padding-y) pb-(--padding-y)",
      )}
      style={
        {
          "--height-px":
            heightPx !== null
              ? heightPx <= 1 && heightPx !== 0
                ? `${heightPx * 100}%`
                : `${heightPx}px`
              : undefined,
          "--padding-y":
            !(heightPx !== null) && !(height === 0)
              ? `${2 ** height * 8}px`
              : undefined,
        } as CSSProperties
      }
    />
  );
}
